var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from "@mui/icons-material/Circle";
import { Stack, Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, styled, Typography, } from "@mui/material";
import { Colors } from "../util/theme";
export var HorizontalStepper = function (_a) {
    var activeStep = _a.activeStep, steps = _a.steps;
    var centralizeActiveStep = function () {
        var stepperContainer = document.getElementById("stepper-container");
        var stepperSteps = stepperContainer.querySelectorAll(".MuiStep-root");
        var activeStepElement = stepperSteps[activeStep];
        if (activeStepElement instanceof HTMLElement) {
            var containerWidth = stepperContainer.offsetWidth;
            var stepWidth = activeStepElement.offsetWidth;
            var offset = containerWidth / 2 - stepWidth / 2;
            stepperContainer.scrollLeft = activeStepElement.offsetLeft - offset;
        }
    };
    useEffect(function () {
        centralizeActiveStep();
    }, []);
    var QontoConnector = styled(StepConnector)(function (_a) {
        var _b, _c, _d;
        var theme = _a.theme;
        return (_b = {},
            _b["&.".concat(stepConnectorClasses.alternativeLabel)] = {
                top: 10,
                left: "calc(-50% + 16px)",
                right: "calc(50% + 16px)",
            },
            _b["&.".concat(stepConnectorClasses.active)] = (_c = {},
                _c["& .".concat(stepConnectorClasses.line)] = {
                    borderColor: "#2E7D32",
                },
                _c),
            _b["&.".concat(stepConnectorClasses.completed)] = (_d = {},
                _d["& .".concat(stepConnectorClasses.line)] = {
                    borderColor: "#2E7D32",
                },
                _d),
            _b["& .".concat(stepConnectorClasses.line)] = {
                borderColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
                borderTopWidth: 3,
                borderRadius: 1,
            },
            _b);
    });
    var QontoStepIconRoot = styled("div")(function (_a) {
        var ownerState = _a.ownerState;
        return (__assign(__assign({ color: "#eaeaf0", display: "flex", height: 22, alignItems: "center" }, (ownerState.active && {
            color: "#0048B6",
        })), { "& .QontoStepIcon-completedIcon": {
                color: "#0048B6",
                zIndex: 1,
                fontSize: 18,
            }, "& .QontoStepIcon-circle": {
                width: 16,
                height: 16,
                borderRadius: "50%",
                backgroundColor: "currentColor",
            } }));
    });
    var QontoStepIcon = function (props) {
        var active = props.active, completed = props.completed;
        return (_jsx(QontoStepIconRoot, __assign({ ownerState: { active: active } }, { children: completed ? (_jsx(CheckCircleIcon, { color: "success" })) : !completed && !active ? (_jsx(CircleIcon, {})) : (_jsx(CircleIcon, { sx: { color: Colors.AZUL_GOV } })) })));
    };
    return (_jsx(Stack, __assign({ paddingX: { xs: "0rem" } }, { children: _jsx(Stack, __assign({ id: "stepper-container", sx: {
                maxWidth: "100vw",
                backgroundColor: "#FFFFFF",
                overflow: "auto",
                overflowX: "hidden",
                overflowY: "hidden",
            }, paddingY: "1rem", alignItems: { md: "center" } }, { children: _jsx(Stepper, __assign({ alternativeLabel: true, activeStep: activeStep, connector: _jsx(QontoConnector, {}) }, { children: steps.map(function (step, index) { return (_jsx(Step, __assign({ sx: {
                        whiteSpace: {
                            xs: "nowrap",
                            md: "normal",
                        },
                    } }, { children: _jsxs(StepLabel, __assign({ StepIconComponent: QontoStepIcon, sx: { alignItems: "center" } }, { children: [_jsxs(Typography, __assign({ fontWeight: "400", fontSize: "0.75rem", sx: { color: "#797979" } }, { children: ["PASSO ", index + 1] })), _jsx(Typography, __assign({ fontWeight: "600", fontSize: "0.8rem", noWrap: true }, { children: step })), activeStep > index ? (_jsx(Typography, __assign({ fontSize: "0.75rem", color: "green" }, { children: "preenchido" }))) : (_jsx(_Fragment, {})), activeStep === index && (_jsx(Typography, __assign({ fontSize: "0.75rem", color: Colors.AZUL_GOV }, { children: "a preencher" }))), activeStep < index && (_jsx(Typography, __assign({ fontSize: "0.75rem", color: "gray" }, { children: "pendente" })))] })) }), index)); }) })) })) })));
};
